module.exports = __webpack_public_path__ + "img/img9.7f93e58c.png";